export const useCartWithSubdomainLogic = (): ReturnType<typeof useCart> => {
  const subdomain = useSubdomain()
  const { isEmbedded } = useEmbeddedCheckout()

  const cartKey = computed(() => {
    if (isEmbedded.value) {
      return 'embedded-instance'
    }

    return subdomain.value || 'general-instance'
  })

  return useCart(cartKey.value)
}
